const initialLoaderId = 'initial-loader';
const initialLoaderReadyEvent = 'portfolio:initial-render';

function initializeLoader(id, readyEvent) {
  const loader = document.getElementById(id);
  if (!loader || document.readyState === 'complete') {
    return;
  }

  const image = loader.querySelector('img');
  let timeout = null;

  const useStillImage = () => {
    console.warn('The Psyduck loader animation could not be loaded; using the still image.');
    const source = loader.querySelector('source');
    if (source) {
      source.remove();
    }
  };

  const dismiss = () => {
    loader.hidden = true;
    window.clearTimeout(timeout);
    window.removeEventListener('load', dismiss);
    window.removeEventListener('pagehide', dismiss);
    document.removeEventListener(readyEvent, dismiss);
    document.removeEventListener('focusin', dismiss);
    document.removeEventListener('pointerdown', dismiss);
    document.removeEventListener('keydown', dismiss);
    image.removeEventListener('error', useStillImage);
  };

  window.addEventListener('load', dismiss);
  window.addEventListener('pagehide', dismiss);
  document.addEventListener(readyEvent, dismiss);
  document.addEventListener('focusin', dismiss);
  document.addEventListener('pointerdown', dismiss);
  document.addEventListener('keydown', dismiss);
  image.addEventListener('error', useStillImage, { once: true });

  // A failed or stalled app bundle must not cover the server-rendered page indefinitely.
  timeout = window.setTimeout(() => {
    console.warn('The initial loader timed out; showing the available page content.');
    dismiss();
  }, 4000);

  loader.hidden = false;
  if (image.complete && image.naturalWidth === 0) {
    useStillImage();
  }
}

const initialLoaderScript = `(${initializeLoader.toString()})(${JSON.stringify(
  initialLoaderId,
)}, ${JSON.stringify(initialLoaderReadyEvent)});`;

module.exports = { initialLoaderId, initialLoaderReadyEvent, initialLoaderScript };
